import React, {useEffect, useState, useCallback} from 'react';

import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {formatErrors, roleTrainee} from "../../constants";
import {rolesAction, roleDeleteAction} from '../../actions/rolesAction';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {Menu} from "../../utils/menu/Menu";
import {SortItem} from "../../utils/sortItem/SortItem";
import {Link} from "react-router-dom";


function Roles(props) {
  const user = useSelector(state => state.user.profile);

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Роли</h2>
      <Link to="/role/0" className="heading__btn heading__btn--invite btn modal-btn">+ Добавить роль</Link>
    </div>  
    {<RolesList user={user} />}
  </div>;
}


function RolesList(props) {
  const {user} = props;
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  

  const deleteRole = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      
      setLoading(true);
      dispatch(roleDeleteAction(id)).then(() => {
        setLoading(false);
        resolve(true);
        getList();
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    })
  };

  const getList = useCallback(() => {
    dispatch(rolesAction()).then((res) => {
      setItems(res.list || []);
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  useEffect(() => {
   getList();
  }, [getList]);

  return <React.Fragment>
    {items && <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Название" className="sort__item--name"/>
          <SortItem title="" className="sort__item--course"/>
        </div>
        <div className="users__inner">
          {items.map((i) => {
            return <div key={i.id} className="users__item">
              <span className="users__name">{i.name}</span>
              
              <ButtonMore>
                <ul className="dropdown">
                  <li className="dropdown__item icon-edit">
                    <Link to={'/role/' + i.id}>Редактировать</Link>
                  </li>
                  {user && user.modules && user.modules['RolePermission'] && <li className="dropdown__item icon-mark">
                    <Link to={'/role-permission/' + i.id}>Разрешения роли</Link>
                  </li>}
                  {i.id > roleTrainee && <li className="dropdown__item icon-delete">
                    <ConfirmModal trigger={<span>Удалить</span>} triggerWrap={false} title={"Удалить роль?"} handleOk={() => deleteRole(i.id)}/>
                  </li>}
                </ul>
              </ButtonMore>
            </div>;
          })}
        </div>
      </div>
    </div>}
  </React.Fragment>;
}

export default Roles
